import { render } from "./SurveyList.vue?vue&type=template&id=21f69158&ts=true"
import script from "./SurveyList.vue?vue&type=script&lang=ts"
export * from "./SurveyList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Surveys/Admin/SurveyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21f69158"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21f69158', __exports__)) {
    api.reload('21f69158', __exports__)
  }
  
  module.hot.accept("./SurveyList.vue?vue&type=template&id=21f69158&ts=true", () => {
    api.rerender('21f69158', render)
  })

}


export default __exports__